<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Manicuristas"
          icon="fas fa-coins"
          btn_name="Manicurista"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :buttonBack="false"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <!-- <CCol sm="12">
            <cSelectForm
              label="Puesto de Trabajo"
              placeholder="Seleccione puesto"
              :options="data_jobpositions"
              :value.sync="barber.job_position_id"
            />
          </CCol> -->
        <CCol sm="12">
          <CSelect
            label="Tipo de documento"
            :value.sync="barber.document_type"
            :options="type_documents"
            placeholder="--Seleccione un documento--"
            @change="onDocumentTypeChange"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Número de documento"
            placeholder="Digite número de documento"
            v-model="barber.document"
            :maxlength="documentMaxLength"
            :disabled="!barber.document_type"
            @input="validateDocument"
          />
          <span v-if="errors.document" class="text-danger">{{
            errors.document
          }}</span>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="barber.name"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Apellido"
            placeholder="Digite apellido"
            v-model="barber.last_name"
          />
        </CCol>
        <CCol sm="12">
          <div class="mb-2">Foto Manicurista</div>
          <input
            @change="getFile"
            type="file"
            class="form-control"
            id="file"
            lang="es"
            name="file"
            ref="fileInput"
            accept=".png,.jpg,.jpeg"
          />
          <div
            v-if="barber.img_barber && modal.action !== 'store'"
            class="container-img"
          >
            <img
              v-if="typeof barber.img_barber === 'string' && barber.img_barber"
              :src="'https://mybarber.howertpi.com/assets/' + barber.img_barber"
              class="img-thumbnail"
              style="max-width: 100px"
              alt="Manicurista"
            />
            <p v-else></p>
          </div>
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="barber.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Servicio'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  // { key: "job_position_name", label: "Puesto", _style: "width:20%;" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "last_name", label: "Apellido", _style: "width:20%;" },
  { key: "document", label: "Documento", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CCol, CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
// import cSelectForm from "../../components/shared/inputs/cSelect.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    // cSelectForm,
  },
  data() {
    return {
      prefix: "barber",
      fields,
      data: [],
      documentMaxLength: 8,
      type_documents: ["DNI", "PASAPORTE", "CARNET EXTRANJERÍA", "RUC"],
      data_jobpositions: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      barber: {
        id: "",
        document: "",
        name: "",
        last_name: "",
        document_type: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        job_position_id: "",
        job_position_name: "",
        img_barber: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      errors: {
        document: "",
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },
  computed: {
    cpStatus: function () {
      if (this.barber.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (
        this.barber.name != "" &&
        this.barber.last_name != "" &&
        this.barber.document != ""
      )
        return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.indexJobPositions();
  },
  methods: {
    ...mapActions(["get", "post"]),
    getFile(e) {
      let fileInput = this.$refs.fileInput;
      let file = e.target.files[0];
      if (
        !/\.(png)$/i.test(file.name) &&
        !/\.(jpg)$/i.test(file.name) &&
        !/\.(jpeg)$/i.test(file.name)
      ) {
        fileInput.value = "";
      } else {
        this.barber.img_barber = file;
      }
    },

    indexJobPositions: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/barber/jobposition/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_jobpositions.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {
          // console.log(errors);
        });
    },
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id +
          "/"+this.$store.getters.get_campu.id+"/2",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          //console.log(response);       
          this.data = response.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.mtd_getdata();
      this.$emit("mtdBack");
    },
    onDocumentTypeChange() {
      if (this.barber.document_type === "DNI") {
        this.documentMaxLength = 8;
      } else if (this.barber.document_type === "RUC") {
        this.documentMaxLength = 11;
      } else if (this.barber.document_type === "PASAPORTE") {
        this.documentMaxLength = 15;
      } else if (this.barber.document_type === "CARNET EXTRANJERÍA") {
        this.documentMaxLength = 9;
      }
    },
    validateDocument() {
      if (
        this.barber.document.length !== this.documentMaxLength ||
        isNaN(this.barber.document)
      ) {
        this.errors.document = `El ${this.barber.document_type} debe tener ${this.documentMaxLength} dígitos y ser un número válido.`;
      } else {
        this.errors.document = "";
      }
    },

    mtd_action: function () {
      let formData = new FormData();
      formData.append("id", this.barber.id);
      formData.append("document", this.barber.document);
      formData.append("name", this.barber.name);
      formData.append("last_name", this.barber.last_name);
      formData.append("company_id", this.barber.company_id);
      formData.append("role_id", 2);
      formData.append("campu_id", this.barber.campu_id);
      // formData.append("job_position_id", this.barber.job_position_id);
      formData.append("img_barber", this.barber.img_barber);
      formData.append("state", this.barber.state);

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: formData,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({ title: "Documento ya registrado", icon: "warning" });
          } else {
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            const color = "success";
            if (this.modal.action == "store") {
              this.mtd_getdata();
            } else {
              this.data = this.data.map((element) =>
                element.Id === response.data[0].Id
                  ? { ...element, ...response.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
            }
            this.modal = { action: "", title: "", modal_form: false };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo(a) Manicurista")
        : (this.modal.title = "Editar Manicurista");
      action == "store"
        ? (this.barber = {
            id: "",
            document: "",
            name: "",
            last_name: "",
            company_id: this.$store.getters.get_company.id,
            campu_id: this.$store.getters.get_campu.id,
            job_position_id: "",
            img_barber: "",
            state: "",
          })
        : (this.barber = this.barber);
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.barber = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          let temp = [];
          this.data.forEach((element) => {
            if (element.Id != response.id) {
              temp.push(element);
            }
          });
          this.data = temp;
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
          this.mtd_getdata();
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.barber.state = payload == true ? 1 : 0;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },

  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
